import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function MortgagePage() {
  const features = [
    {
      title: "First-Time Buyers",
      desc: "Guiding you through the mortgage process with expert advice, simplifying the journey to home ownership, and securing the best deal for your new beginning.",
    },
    {
      title: "Home Movers",
      desc: "Whether you're upsizing, downsizing, or relocating, we make transitioning to your new home seamless and stress-free with competitive mortgage options.",
    },
    {
      title: "Buy-to-Let",
      desc: "Helping landlords and investors find flexible, cost-effective mortgage options to maximize their property investments.",
    },
    {
      title: "Remortgaging",
      desc: "Assisting you in finding better rates, releasing equity, or managing your finances more effectively with a remortgage tailored to your goals.",
    },
  ];

  return (
    <div data-testid="mortgage-page">
      <section className="relative bg-[#111111] py-32 lg:py-40">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1920&q=80')] bg-cover bg-center opacity-15" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#d64241] font-semibold text-sm tracking-widest uppercase mb-3 font-body">Mortgage Service</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight">
            Mortgage<br />
            <span className="text-[#d64241]">Solutions</span>
          </h1>
        </div>
      </section>

      <section data-testid="mortgage-content" className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div>
              <div className="w-14 h-14 rounded-xl bg-[#fef2f2] flex items-center justify-center mb-6">
                <Home className="w-7 h-7 text-[#d64241]" />
              </div>
              <h2 className="text-3xl md:text-4xl font-semibold text-black tracking-tight mb-6">
                Personalised Mortgage Solutions
              </h2>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 font-body">
                At KK Mortgage Solutions, we specialise in delivering tailored mortgage solutions to meet the unique needs of every client. Whether you're stepping onto the property ladder for the first time, upgrading to your dream home, exploring investment opportunities, or looking to optimise your current mortgage, we've got you covered.
              </p>
              <div className="space-y-6 mb-10">
                {features.map((f, i) => (
                  <div key={i} className="flex gap-4">
                    <CheckCircle2 className="w-5 h-5 text-[#d64241] flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-semibold text-black mb-1">{f.title}</h3>
                      <p className="text-sm text-gray-600 font-body leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 font-body">
                We're committed to providing transparent, personalised, and professional service every step of the way. With our in-depth market knowledge and dedication to client success, you can trust us to make your mortgage experience as smooth and rewarding as possible.
              </p>
              <Link to="/contact">
                <Button data-testid="mortgage-cta-btn" className="bg-[#d64241] hover:bg-[#b53736] text-white rounded-full px-8 py-6 text-base font-semibold shadow-lg shadow-[#d64241]/25 hover:-translate-y-0.5 transition-all duration-200">
                  Get a Quote <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
            </div>
            <div>
              <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.1)]">
                <img src="https://images.unsplash.com/photo-1680576554984-efa06cb96392?w=800&q=80" alt="Mortgage consultation" className="w-full h-[400px] lg:h-[550px] object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
